import { LabResult } from '../lab-results-service/types';
import type { PaginatedData } from '../types';
import type { User } from '../user-service/types';
import type { Event } from '../event-service/types';
import { Kit } from '../kit-service/types';

interface ShopifyLineItemNode {
  node: {
    id: string;
    title: string;
    product: {
      id: string;
    };
  };
}

interface ShopifyCustomAttribute {
  key: string;
  value: string;
}

interface ShopifyOrder {
  id: string;
  name: string;
  customAttributes: ShopifyCustomAttribute[];
  createdAt: string;
  lineItems: {
    edges: ShopifyLineItemNode[];
  };
  customer: {
    id: string;
  };
}

export interface TestKit {
  id: number;
  OrderId: number;
  CustomerId: number;
  LabResultId: number;
  status: string;
  shippedDate: string;
  receivedDate: string;
  approvingPhysician: number;
  additionalInfo: { [key: string]: unknown };
  sampleCollectionDate?: Date;
  fastingStatus?: string;
  note?: string;
  approvingPhysicianFirstName?: string;
  approvingPhysicianLastName?: string;
}

export enum OrderStatus {
  NEW = 'NEW',
  ORDER_APPROVED = 'ORDER APPROVED',
  ORDER_REJECTED = 'ORDER REJECTED',
  RELEASE_APPROVED = 'RELEASE APPROVED',
  RELEASE_REJECTED = 'RELEASE REJECTED',
  KIT_SHIPPED = 'KIT SHIPPED',
  SPECIMEN_RECEIVED = 'SPECIMEN RECEIVED',
  RECOLLECTION_REQUIRED = 'RECOLLECTION REQUIRED',
  COMPLETED = 'COMPLETED',
  KIT_REGISTERED = 'KIT REGISTERED'
}

export enum OrderType {
  online = 'online',
  'on-site' = 'on-site',
  'retail' = 'retail'
}
export interface Order {
  clientId: string;
  event?: Event;
  id: number;
  orderId: number;
  UserId: number;
  name: string;
  orderType: OrderType;
  orderDate: string;
  shopifyId: string;
  shopifyGraphQLId: string;
  productSlugs: string[];
  cancelled: boolean;
  createdAt: string;
  updatedAt: string;
  user: User;
  status: OrderStatus;
  testKit?: TestKit;
  shopifyData?: ShopifyOrder;
  labResult?: LabResult;
  kit: Kit
}

export interface OrderList extends PaginatedData {
  items: Order[];
}
